'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Faq } from '@/components/landing-faq';
import { Button } from '@/components/ui/button';
import { SiDiscord } from '@icons-pack/react-simple-icons';
import useRudderStackAnalytics from '@/hooks/useRudderAnalytics';
import { useEffect, useRef } from 'react';
import { useSubscription } from '@/hooks/useSubscription';
import { useSession } from 'next-auth/react';
import { getNativePlatform, getPlatformOS } from '@/lib/utils/platform';
import { useFirstTouchUTM } from '@/hooks/use-first-touch-utm';
export default function SupportPage() {
  const $ = _c(16);
  const analytics = useRudderStackAnalytics();
  const {
    data: session
  } = useSession();
  const firstTouchUTM = useFirstTouchUTM();
  const hasTrackedPageView = useRef(false);
  const t0 = session?.user?.id;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      userId: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    subscriptionData: rawSubscriptionData
  } = useSubscription(t1);
  let t2;
  if ($[2] !== analytics || $[3] !== firstTouchUTM || $[4] !== rawSubscriptionData?.hasActiveSubscription || $[5] !== rawSubscriptionData?.subscription?.status || $[6] !== rawSubscriptionData?.subscription?.subscriptionType) {
    t2 = () => {
      if (!analytics || hasTrackedPageView.current) {
        return;
      }
      hasTrackedPageView.current = true;
      analytics.page("Support Page", {
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        url: window.location.href,
        pathname: window.location.pathname,
        search: window.location.search,
        origin: window.location.origin,
        hostname: window.location.hostname,
        ...firstTouchUTM
      }, {
        traits: {
          platform: getNativePlatform(),
          os: getPlatformOS(),
          plan: rawSubscriptionData?.subscription?.subscriptionType || "basic",
          has_active_subscription: rawSubscriptionData?.hasActiveSubscription || false,
          subscription_status: rawSubscriptionData?.subscription?.status || "none"
        }
      });
    };
    $[2] = analytics;
    $[3] = firstTouchUTM;
    $[4] = rawSubscriptionData?.hasActiveSubscription;
    $[5] = rawSubscriptionData?.subscription?.status;
    $[6] = rawSubscriptionData?.subscription?.subscriptionType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = rawSubscriptionData?.subscription?.subscriptionType;
  const t4 = rawSubscriptionData?.hasActiveSubscription;
  const t5 = rawSubscriptionData?.subscription?.status;
  let t6;
  if ($[8] !== analytics || $[9] !== firstTouchUTM || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = [analytics, t3, t4, t5, firstTouchUTM];
    $[8] = analytics;
    $[9] = firstTouchUTM;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t2, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Faq />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <main className="min-h-screen bg-black text-white md:grid md:place-items-center">{t7}<section className="container px-4 py-8 md:py-12"><div className="mx-auto max-w-xl w-full flex justify-center"><Link href="https://discord.gg/QurJK5p7GJ" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto"><Button size="lg" className="w-full sm:w-auto gap-2 justify-center"><SiDiscord className="size-4" aria-label="Discord" />Entrar no Discord</Button></Link></div></section></main>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}